import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    light: true,
    themes: {
      light: {
        primary: '#410E47',
        secondary: '#A086BD',
        accent: '#D0FF59',
        error: '#C10C1A',
        info: '#3095C1',
        success: '#01544C',
        warning: '#FFB7BC',
        background: '#FFFFFF'
      },
      dark: {
        primary: '#410E47',
        secondary: '#A086BD',
        accent: '#D0FF59',
        error: '#C10C1A',
        info: '#3095C1',
        success: '#01544C',
        warning: '#FFB7BC'
      }
    }
  }
})
